import { IMatchStatisticsDetail } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchStatisticsQuery } from './typeguards';
import { CreateLmpStatisticsInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchStatisticsQuery } from '../types';


export default (obj: LmpMatchStatisticsQuery): IMatchStatisticsDetail => {
  if (isValidLmpMatchStatisticsQuery(obj)) {
    CreateLmpStatisticsInputSchema().parse(obj.data.getLmpStatistics, { reportInput: true });
    
    const { createdAt, updatedAt, ...statistics} = obj.data.getLmpStatistics;

    const payload: IMatchStatisticsDetail = {
      matchStatisticsDetails: statistics as IMatchStatisticsDetail['matchStatisticsDetails']
    }

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchStatisticsQuery object',
      data: obj,
    });
  }
};
